import { useThemeStore } from "../stores/themeStore";
import {
  CHART_CHROME,
  CHART_CHROME_DARK,
  CHART_PALETTE,
  CHART_PALETTE_DARK,
  CHART_SERIES_COLORS,
  CHART_SERIES_COLORS_DARK,
} from "../theme/chartColors";

export function useChartColors() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);
  return resolvedTheme === "dark" ? CHART_PALETTE_DARK : CHART_PALETTE;
}

export function useChartSeriesColors() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);
  return resolvedTheme === "dark" ? CHART_SERIES_COLORS_DARK : CHART_SERIES_COLORS;
}

export function useChartChrome() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);
  return resolvedTheme === "dark" ? CHART_CHROME_DARK : CHART_CHROME;
}
